<template>
  <div>
    <div class="form-group form-group-border-bottom align-items-center d-flex flex-row position-relative" dir="rtl">
      <label  v-if="label">
        <span v-if="field.required" class="required">*</span>{{label}}
    </label>
    <input ref="inputField" type="text" class="form-control-plaintext formselect flex-grow-1" :list="`datalistOptions_${name}`" :id="name" :name="name" :required="field.required" @focus="selectEvent(false, true)" @blur="selectEvent(true, false)">
    <datalist :id="`datalistOptions_${name}`" dir="rtl" style="text-align:right;">
      <option v-for="opt in options" :value="opt.text" :key="opt.val"></option>
    </datalist>
    <CaretComponent :open="open" @click="focusInput" class="caret-clickable" />
    </div> 
    <div class="invalid-feedback" :id="`${name}invalid`">{{field.error_message}}</div>
  </div>
</template>
<script>
import CaretComponent from "@/components/CaretComponent";
export default {
  components: {
    CaretComponent
  },
  props: {
    label: String,
    type: String,
    name: String,
    selected: String,
    options: Array,
    field: Object,
    simple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false
    }
  },
  methods: {
    selectEvent(trustedEvent, value) {
      if (trustedEvent) {
        this.open = value;
        return;
      }
      this.open = value;
    },
    focusInput() {
      // Focus the input field when caret is clicked, which will show the datalist dropdown
      this.$refs.inputField.focus();
    }
  }
}
</script>
<style scoped>
.formselect {
  display: block;
  padding: 0.375rem 0.75rem 0.375rem 2.5rem;
  -moz-padding-start: calc(0.75rem - 3px);
  background-color: inherit;
  border: 0;
  min-height: 39px;
  max-width: 400px;
}

/* Hide the native datalist dropdown indicator (caret) for Chrome/Safari/Edge */
.formselect::-webkit-calendar-picker-indicator {
  display: none !important;
  -webkit-appearance: none !important;
  opacity: 0 !important;
  pointer-events: none !important;
  width: 0 !important;
  height: 0 !important;
}

.formselect::-webkit-list-button {
  display: none !important;
  -webkit-appearance: none !important;
  opacity: 0 !important;
  pointer-events: none !important;
  width: 0 !important;
  height: 0 !important;
}

/* For Firefox - hide datalist indicator */
.formselect {
  -moz-appearance: none;
  appearance: none;
}
.formselect::-moz-list-bullet {
  display: none;
}

/* For IE/Edge */
.formselect::-ms-expand {
  display: none;
}

.formselect:focus,
.formselect:active {
  border: 0;
  outline: none;
}

.caret-clickable {
  cursor: pointer;
  pointer-events: auto;
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}

.caret-position {
  position: relative;
  top: -3px;
}
.required {
  color: red;
  margin-left: 5px;
}

@media (min-width: 1200px) {
  .caret-position {
    top: inherit;
  }
}
</style>